export const lineOverviewTranslations = {
  // Connect gate
  title: "LINE OA",
  connectTitle: "Connect LINE Messaging API",
  connectDesc:
    "Connect your LINE Messaging API in Storefront Settings to access this dashboard.",
  connectCta: "Go to Settings",

  // Header
  switchOA: "Switch LINE OA",
  friends: "friends",
  lineSettings: "LINE settings",

  // Error
  loadError: "Couldn't load data from LINE. Try again.",
  retry: "Retry",

  // Hero cards
  broadcasts: "Broadcasts",
  broadcastsDesc: "Broadcast messages to all your friends.",
  sendBroadcast: "Send a broadcast",
  campaigns: "Campaigns",
  campaignsDesc: "Target customers by their orders and send.",
  createCampaign: "Create a campaign",

  // Friends insights
  friendsTitle: "Friends",
  audience: "Audience",
  trends: "Trends",
  period7d: "7 days",
  period30d: "30 days",
  period90d: "90 days",
  metric: "Metric",
  change: "Change",
  trend: "Trend",
  metricFriends: "Friends",
  metricTargetReach: "Target reach",
  metricNewFollowers: "New followers",
  notEnoughData:
    "Not enough follower data yet — insights appear once your account has activity.",

  // Broadcasts panel
  yourBroadcasts: "Your broadcasts",
  messagesThisMonth: "messages this month",
  sendBroadcastShort: "Send broadcast",
  pastBroadcast: "Past broadcast",
  delivered: "Delivered",
  opens: "Opens",
  uniqueClicks: "Unique clicks",
  imageMessage: "Image message",
  opensClicksNote:
    "Opens & clicks come from LINE and can take a few hours to appear after sending.",
  noBroadcasts:
    "No broadcasts sent yet. Send your first one to reach all your friends.",

  // Automated notifications
  automatedNotifications: "Automated notifications",
  automatedNotificationsDescPre:
    "Messages your store sends customers automatically. Toggle them in ",
  automatedNotificationsDescPost: ".",
  on: "On",
  off: "Off",
  lastSent: "Last sent",
  noneSentYet: "none sent yet",
  sent: "sent",
  thisMonthShort: "this mo.",

  // Notification types
  notif_order_confirmation: "Order confirmation",
  notif_order_confirmation_desc: "When a new order is placed",
  notif_payment_confirmation: "Payment confirmation",
  notif_payment_confirmation_desc: "When payment is received",
  notif_payment_reminder: "Payment reminder",
  notif_payment_reminder_desc: "When an order is awaiting payment",
  notif_shipment: "Shipment tracking",
  notif_shipment_desc: "When an order has shipped",
  notif_booking_confirmation: "Booking confirmation",
  notif_booking_confirmation_desc: "When a booking is created",

  // Payment reminders
  paymentReminders: "Payment reminders",
  remindersSent: "Reminders sent",
  clicks: "Clicks",
  paidAfter: "Paid after",
  conversionPct: "Conversion %",

  // Targeted campaigns (send history + stats)
  campaignSectionTitle: "Targeted campaigns",
  campaignSectionDesc: "Messages sent to hand-picked customer segments",
  campaignStatTotalSends: "Total sends",
  campaignStatTotalDelivered: "Total delivered",
  campaignStatSuccessful: "Successful",
  campaignHistoryTitle: "Send history",

  // Secondary actions
  richMenus: "Rich menus",
  richMenusDesc: "Create bottom menus for your friends",
  audienceDesc: "Browse your follower profiles",

  // Store switcher
  switchOALong: "Switch LINE OA / store",
  primary: "Primary",
}
